/**
 * Format a duration in milliseconds to a human-readable string.
 * Returns '—' for null, undefined, zero, negative, or illogically large values.
 *
 * Threshold: durations exceeding 7 days (604_800_000 ms) are considered garbage
 * from incorrect action progress persistence and are hidden.
 */
const MAX_REASONABLE_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export const formatDuration = (ms: number | null | undefined): string => {
  if (ms === null || ms === undefined || ms <= 0) return '—';
  if (ms > MAX_REASONABLE_DURATION_MS) return '—';

  const seconds = Math.floor(ms / 1000);
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (minutes < 60) return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours < 24) return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;

  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;
  return remainingHours > 0 ? `${days}d ${remainingHours}h` : `${days}d`;
};
